import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/pages/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/publish'
      },
      {
        path: '/publish',
        name: 'ProductPublish',
        component: () => import('@/views/publish/ProductPublish.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/tasks',
        name: 'Tasks',
        component: () => import('@/views/tasks/Tasks.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/task-review',
        name: 'TaskReview',
        component: () => import('@/views/tasks/TaskReview.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/devices',
        name: 'Devices',
        component: () => import('@/views/devices/Devices.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/device-monitor',
        name: 'Devices',
        component: () => import('@/views/devices/Devices.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/realtime',
        name: 'RealtimeMonitor',
        component: () => import('@/views/monitor/RealtimeMonitor.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/alerts',
        name: 'DeviceAlert',
        component: () => import('@/views/alert/DeviceAlert.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/maintenance',
        name: 'Maintenance',
        component: () => import('@/views/maintenance/Maintenance.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/element-test',
        name: 'ElementTest',
        component: () => import('@/views/test/ElementTest.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/Dashboard.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/products',
        name: 'ProductCenter',
        component: () => import('@/views/products/ProductCenter.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/profile',
        name: 'UserProfile',
        component: () => import('@/views/profile/UserProfile.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/feedback',
        name: 'Feedback',
        component: () => import('@/views/feedback/Feedback.vue'),
        meta: { requiresAuth: true }
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: { requiresAuth: false }
  },
  // 404页面
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/views/error/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const isLoggedIn = !!token
  
  // 需要登录但未登录，重定向到登录页
  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    next({ name: 'Login' })
  } else {
    // 已登录且访问登录页，重定向到首页（使用replace防止在历史记录中保留登录页）
    if (isLoggedIn && to.name === 'Login') {
      next({ path: '/', replace: true })
    } else {
      next()
    }
  }
})

export default router
